import { Slider } from '@mui/material';
import { intToPx, toInt } from 'pages/StyleEditor/helpers';
import React from 'react';
import Row from './Row';

type Props = {
	value: string;
	onChange: (value: string) => void;
	label: string;
	// eslint-disable-next-line react/require-default-props
	'data-testid'?: string;
};

export default ({
	value,
	onChange,
	label,
	'data-testid': dataTestId
}: Props) => (
	<Row label={label} data-testid={dataTestId}>
		<Slider
			max={50}
			value={toInt(value)}
			size="small"
			sx={{ width: 120 }}
			onChange={(_, val) => onChange(intToPx(val as number))}
		/>
	</Row>
);
